import getConfig from 'next/config';

const { serverRuntimeConfig } = getConfig();
export const pageview = (url: URL | string): void =>
    gtag('config', serverRuntimeConfig.UA_TRACKING_ID, {
        page_path: url
    });
